export const WECARE_ORGANIZATION_SLUG = 'wecare-health';

export function hasWeCareWorkforceSuite(organizationSlug) {
  return String(organizationSlug || '').trim().toLowerCase() === WECARE_ORGANIZATION_SLUG;
}

export function resolveWorkforceTabAccess(organizationSlug, capabilities = {}) {
  const enabled = hasWeCareWorkforceSuite(organizationSlug);

  return {
    enabled,
    canSeeMyPto: enabled,
    canSeeAllBalances: enabled && Boolean(capabilities.canEditSchedules),
    canSeeApprovals: enabled && Boolean(capabilities.canSeeApprovalsTab),
    canSeeConfiguration: enabled && Boolean(capabilities.canSeeConfigurationTab),
    canSeeTimeOffQueue: enabled && Boolean(capabilities.canViewTimeOffQueue),
    canSeeClockedIn: enabled && Boolean(capabilities.canSeeClockedIn),
  };
}
